export const state = () => ({
	isOpen: false,
	onSubmit: null
});

export const mutations = {
	onOpen(state, { onSubmit }) {
		state.isOpen = true;
		state.onSubmit = onSubmit;
	},
	onClose(state) {
		state.isOpen = false;
		state.onSubmit = null;
	}
};
